import { useCallback, useState } from 'react';
import { Form, InputGroup, Spinner } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import { Check } from 'react-bootstrap-icons';
import { PATH_TAGS } from '../../../../static-resources/static-misc';
import { ButtonPrimary } from '../../../buttons/button-primary.component';

interface AppCopyToClipboardModalProps {
  show: boolean;
  onClose?(show: boolean): void;
  title: string;
  link: string;
}

const getLinkName = (link: string) => {
  const parsed = new URL(link);
  const path = parsed.pathname;
  if (path) {
    const tag = PATH_TAGS[path];
    if (tag) {
      return tag[0].title;
    }
  }
  return 'Link';
};

export const AppCopyToClipboardModal = ({
  show,
  onClose,
  title,
  link,
}: AppCopyToClipboardModalProps) => {
  const [succeed, setSucceed] = useState<boolean | undefined>(undefined);
  const [isCopying, setIsCopying] = useState<boolean | undefined>(undefined);

  const handleClose = () => {
    if (onClose) onClose(false);
    setIsCopying(undefined);
    setSucceed(undefined);
  };

  const copyToClipboard = useCallback(() => {
    setIsCopying(false);
    const name = getLinkName(link);
    const clipboardItem = new ClipboardItem({
      'text/plain': new Blob([link], { type: 'text/plain' }),
      'text/html': new Blob([`<A href="${link}">IRIS - ${name}</A>`], {
        type: 'text/html',
      }),
    });

    navigator.clipboard
      .write([clipboardItem])
      .catch(() => {
        setSucceed(false);
      })
      .then(() => {
        setSucceed(true);
      })
      .finally(() => {
        setIsCopying(false);
      });
  }, [link]);
  return (
    <>
      <Modal show={show} onHide={handleClose} keyboard={false} centered={true}>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <InputGroup className="mb-3">
            <Form.Control
              value={link}
              type="text"
              id="link"
              disabled
              aria-describedby="helpBlock"
            />
            <ButtonPrimary variant="sm" onClick={() => copyToClipboard()}>
              Copy
            </ButtonPrimary>
          </InputGroup>

          <Form.Text id="helpBlock" muted>
            {isCopying === true && <Spinner />}
            {succeed === undefined && <span>{`Please, click on "Copy"`}</span>}
            {succeed === true && (
              <span>
                <Check color="var(--success500)" /> Link copied!
              </span>
            )}
            {succeed === false && (
              <span>
                <Check color="var(--error500)" /> Error
              </span>
            )}
          </Form.Text>
        </Modal.Body>
      </Modal>
    </>
  );
};
